import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ModuleGuard = ({ requiredModule }) => {
  const activeModule = useSelector((state) => state.module.activeModule);
  const hasAccess = activeModule === requiredModule;

  if (!hasAccess) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default ModuleGuard;